import React from "react";
import PropTypes from "prop-types";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import Slide from "@material-ui/core/Slide";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import { useTheme } from "@material-ui/core/styles";

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="down" ref={ref} {...props} />;
});

function ConfirmDialog({
    open,
    title,
    content,
    primaryButtonText,
    secondaryButtonText,
    onClose,
    onPrimaryClick,
    onSecondaryClick,
}) {
    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));

    return (
        <div>
            <Dialog
                open={open}
                fullScreen={fullScreen}
                TransitionComponent={Transition}
                keepMounted
                onClose={onClose}
                aria-labelledby="alert-dialog-slide-title"
                aria-describedby="alert-dialog-slide-description">
                <DialogTitle id="alert-dialog-slide-title">{title}</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-slide-description">{content}</DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={onSecondaryClick} color="default">
                        {secondaryButtonText}
                    </Button>
                    <Button variant="contained" onClick={onPrimaryClick} color="primary">
                        {primaryButtonText}
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
}

ConfirmDialog.propTypes = {
    open: PropTypes.bool,
    title: PropTypes.node,
    content: PropTypes.node,
    primaryButtonText: PropTypes.string,
    secondaryButtonText: PropTypes.string,
    onClose: PropTypes.func.isRequired,
    onPrimaryClick: PropTypes.func,
    onSecondaryClick: PropTypes.func,
};

ConfirmDialog.defaultProps = {
    open: false,
    title: "",
    content: "",
    primaryButtonText: "Yes",
    secondaryButtonText: "No",
    onPrimaryClick: () => {},
    onSecondaryClick: () => {},
};

export default ConfirmDialog;
